/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Formik, Form as FormikForm } from 'formik';
import NiceLogo from '../../assets/logos/NiceLogo.png';
import NInput from '../inputs/NInput';
import NButton from '../inputs/NButton';
import { otpValidation } from '../../validations/validation';

function VerifyOtp(props) {
  const {
    userName,
    phonePart,
    emailPart,
    errorMessage,
    onSubmit,
    isLoading,
    onClickSendOtpToMail,
  } = props;
  const [isClickedSendToMail, setIsClickedSendToMail] = useState(false);

  return (
    <div className='text-left'>
      <Formik
        initialValues={{ code: '' }}
        validationSchema={otpValidation}
        onSubmit={(values, formikBag) => {
          onSubmit(values, formikBag);
        }}
        enableReinitialize
      >
        {({ touched, values, errors, handleSubmit, handleChange, handleBlur }) => (
          <FormikForm autoComplete='off' onSubmit={handleSubmit}>
            <div className='mb-10'>
              <img src={NiceLogo} alt='NiceLogo' />
            </div>
            <div className='mb-10'>
              <h4 className='text-black-100 mb-2.5 text-2xl font-semibold'>
                {phonePart === '' ? 'Verify Email' : 'Verify phone'}
              </h4>
              <p className='text-black-100 text-xs font-normal'>
                {isClickedSendToMail && emailPart
                  ? `Code is sent to your email ${emailPart}`
                  : phonePart
                  ? `Code is sent to your phone number *********${phonePart}`
                  : `Code is sent to your email ${emailPart}`}
              </p>
            </div>
            <div className='mb-10'>
              <div className='relative'>
                <NInput
                  autofocus
                  name='code'
                  value={values.code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={(errors.code && touched.code) || errorMessage}
                  helperText={errors.code && touched.code ? errors.code : '' || errorMessage}
                  className='w-full'
                  label='OTP'
                  placeholder='Enter your OTP code here'
                  type='text'
                />
              </div>
            </div>
            <div className='mb-5'>
              <p className='text-sm text-black'>
                Didn't receive OTP?
                <span
                  className='cursor-pointer font-bold text-nblue hover:underline'
                  onClick={() => {
                    if (isLoading) return;
                    setIsClickedSendToMail(true);
                    onClickSendOtpToMail({ userName, mailOTP: true });
                  }}
                >
                  {isClickedSendToMail ? ' Send again' : ' Click here'}
                </span>
                <span className='text-sm text-black'>
                  {!isClickedSendToMail && ' to get it on your Email'}
                </span>
              </p>
            </div>
            <div>
              <NButton
                isLoading={isLoading}
                onClick={handleSubmit}
                className='!w-full !rounded-[10px] !bg-black !py-[18px]'
              >
                Verify
              </NButton>
            </div>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
}

VerifyOtp.propTypes = {
  userName: PropTypes.string.isRequired,
  phonePart: PropTypes.string.isRequired,
  emailPart: PropTypes.string,
  errorMessage: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClickSendOtpToMail: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

VerifyOtp.defaultProps = {
  isLoading: false,
  emailPart: '',
};

export default VerifyOtp;
